module.exports = __webpack_public_path__ + "media/images/monthly8-18bae4e4f08e7a6383268a91a09f91cb.jpg";